<template>
  <div id="this-is-geobeta">
    <div class="main-container">
      <h2 class="geobeta__heading heading--md heading--underlined">
        ENTER THE WASTELAND
      </h2>
      <p class="geobeta__description">
        Mini DayZ 2 drops you square in the middle of a <strong>zombie apocalypse</strong>.
        Embark on dangerous <strong>Raids</strong> to gather food and materials then use them to
        build a safe haven for your group of survivors. Hop into <strong>multiplayer</strong>
        mode to join forces with your friend or with survivors from around the
        globe. Work together to preserve humanity on both <strong>Android</strong> and <strong>iOS</strong> mobile
        devices!
      </p>
      <!-- <p class="geobeta__description">
                Mini DayZ 2 is now being <strong>publicly tested</strong> all around the world. Which means you can
                download the game right now on <strong>Android and iOS devices</strong> directly from the app store!
            </p> -->
      <!-- <p class="geobeta__description">
                In case you’ve never played Mini DayZ 2 before, the game drops you square in the middle of a
                <strong>zombie apocalypse</strong>. There’s nowhere to run and the only way to survive is by building a
                camp with fellow survivors. Do you have what it takes to make it?
            </p> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "ThisIsGeobeta",
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/vars";

#this-is-geobeta {
  padding: 7em 0 4em;
  .geobeta__heading {
    margin-bottom: em(120, 31);

    @media (max-width: $screen-lg-down) {
      margin-bottom: 1.5em;
    }
  }
  .geobeta__description {
    font-family: "Metron Book", sans-serif;
    font-size: 1.6em;
    font-weight: 400;
    line-height: 1.7;
    letter-spacing: 0.035em;
  }
}
</style>
